import t from "@/lang/lang";
import {
  BaseDataPage,
  BaseDataPageContent,
  BaseDataPageHeader,
  BaseDataPageTitle,
} from "@/routes/base-data/_components/layout/base-data-page";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@/shared/components/ui/tabs";
import { CompanyMatchesCard } from "@/services/backend/business-central/components/company-matches-card";
import { ServiceKindMatchesCard } from "@/services/backend/business-central/components/service-kind-matches-card";

export function MatchesRoute() {
  return (
    <BaseDataPage>
      <BaseDataPageHeader>
        <BaseDataPageTitle>{t("Business Central Matches")}</BaseDataPageTitle>
      </BaseDataPageHeader>
      <BaseDataPageContent>
        <Tabs defaultValue="companies">
          <TabsList>
            <TabsTrigger value="companies">{t("Unternehmen")}</TabsTrigger>
            <TabsTrigger value="serviceKinds">
              {t("Dienstleistungen")}
            </TabsTrigger>
          </TabsList>
          <TabsContent value="companies">
            <CompanyMatchesCard />
          </TabsContent>
          <TabsContent value="serviceKinds">
            <ServiceKindMatchesCard />
          </TabsContent>
        </Tabs>
      </BaseDataPageContent>
    </BaseDataPage>
  );
}
